import { Group } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import DataWrapper from "../../../../common/components/DataWrapper/DataWrapper";
import { filterOptions, sortOptions } from "../../utils/motherCovers";
import useRbac from "../../../../common/hooks/useRbac/useRbac"; 

const MotherCover = () => {
  const { checkPermission } = useRbac();
  const navigate = useNavigate();
  const endpoint = "cover-api/mother-covers/";

  const handleView = (row) => `${row.id}`;
  const handleEdit = (row) => `${row.id}/edit`;
  const handleBenefitsView = (row) => `${row.id}/benefits/`;

  const config = {
    fields: [
      { key: "token", label: "Plan Code" },
      { key: "title", label: "Plan Name" },
      { key: "cover_scope", label: "Geo. Scope" },
      { key: "partner_name", label: "Premium Partner" },
      { key: "is_expired", label: "Status", type: "status" },
    ],
    actions: [
      { label: "View", to: (row) => handleView(row) },
      ...(checkPermission("update") ? [{ label: "Edit", to: (row) => handleEdit(row) }] : []),
      { label: "Benefits", to: (row) => handleBenefitsView(row) },
    ],
    selectionActions: checkPermission("create")
    ? [
        {
          label: "+ Add Mother Plan",
          handler: () => {
            navigate("create");  
          },
        },
      ]
    : [],
    rowClickTo: (row) => handleView(row),
    doubleClickRow: true,
  };

  return (
    <>
      <Group align="center" gap="sm">
      </Group>
      <DataWrapper
        endpoint={endpoint}
        filterOptions={filterOptions}
        sortOptions={sortOptions}
        config={config}
        swrConfig={{ revalidateOnFocus: false, revalidateOnReconnect: false }}
      />
    </>
  );
};

export default MotherCover;